<template>
  <PCSettingsBlock
    v-if="hasVisibleItems"
    :title="t('userConfiguration.picking.title')"
  >
    <PCSettingsBlockItem
      v-if="replanifyQuantity"
      :title="t('userConfiguration.picking.automaticReplanification')"
    >
      <template #right>
        <f7-toggle
          v-model:checked="replanifyQuantityAuto"
        />
      </template>
    </PCSettingsBlockItem>
  </PCSettingsBlock>
</template>

<script setup>
// @ts-check
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

import PCSettingsBlock from './PCSettingsBlock.vue';
import PCSettingsBlockItem from './PCSettingsBlockItem.vue';

const { t } = useI18n();
const replanifyQuantity = useParamRef('ReplanificarCantidadPaleTraspasadoOReprocesado');
const replanifyQuantityAuto = useSettingRef('Picking.ReplanificarCantidadPaleTraspasadoOReprocesadoAutomaticamente');

const hasVisibleItems = computed(() => replanifyQuantity.value);
</script>
